import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useState, useEffect, useContext } from "react";
import Modal from '@mui/material/Modal';
import DocTitle from "../components/DocTitle";
import DocAlert from "../components/DocAlert";
import { Breadcrumbs, IconButton } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import CloseIcon from '@mui/icons-material/Close';
import httpClient from "../httpClient";
import commonContext from "../contexts/common/commonContext";
import AddIcon from '@mui/icons-material/Add';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import revalidate from "../utils/revalidate";
import { getCategoryFolderName } from "../data/constants";

const AddItem = () => {

    const navigate = useNavigate();
    const { user } = useContext(commonContext);
    
    useEffect(() => {
        if(user===null) {
            navigate('/login/');
        }
    }, [user, navigate]);

    const [CategoryData, setCategoryData] = useState([]);
    const [SubcategoryData, setSubcategoryData] = useState([]);
    const [chSubcategoryData, setChSubcategoryData] = useState([]);
    const [productsData, setProductsData] = useState([]);

    const [itemName, setItemName] = useState("");
    const [category, setCategory] = useState("");
    const [subcategory, setSubcategory] = useState("");
    const [salePrice, setSalePrice] = useState(0);
    const [tag, setTag] = useState("");
    const [tagline, setTagline] = useState("");
    const [description, setDescription] = useState("");
    const [itemImages, setItemImages] = useState([]);
    
    const [alertCont, setAlertCont] = useState("");
    const [alertError, setAlertError] = useState(0);
    const [adding, setAdding] = useState(false);
    
    const [chId, setChId] = useState(0);
    const [chItemName, setChItemName] = useState("");
    const [chCategory, setChCategory] = useState("");
    const [chSubcategory, setChSubcategory] = useState("");
    const [chSalePrice, setChSalePrice] = useState(0);
    const [chTag, setChTag] = useState("");
    const [chTagline, setChTagline] = useState("");
    const [chDescription, setChDescription] = useState("");
    const [chItemImages, setChItemImages] = useState([]); // New state for edit images
    const [pageSize, setPageSize] = useState(10);

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => {setOpen(false); setChItemImages([]);};
    
    const columns = [
        {field: "srno", headerName: "#", headerAlign: "center", width: 100, align: "center"},
        {field: "title", headerName: "ITEM", headerAlign: "center", width: 150, align: "left"},
        {field: "category", headerName: "CATEGORY", headerAlign: "center", width: 100, align: "center"},
        {field: "finalPrice", headerName: "PRICE", headerAlign: "center", width: 70, align: "center"},
        {field: "edit", headerName: "EDIT", headerAlign: "center", align: "center", width: 100, 
            renderCell: (params) => {
                return (
                    <div className="table-edit-button">
                        <button onClick={() => handleEdit(params.row)}>Edit</button>
                    </div>
                )
            }
        },
        {field: "delete", headerName: "DELETE", headerAlign: "center", align: "center", width: 100, 
            renderCell: (params) => {
                return (
                    <div className="table-delete-button">
                        <button onClick={() => handleDelete(params.row)}>Delete</button>
                    </div>
                )
            }
        },
    ];
    
    useEffect(() => {
        httpClient.get('/categoryData')
            .then(res => {
                // console.log(res);
                setCategoryData(res.data);
            });

        httpClient.get('/allProductsData')
        .then(res => {
                let tmp1 = [];
                let tmp2 = [];
                if(res.data) {
                    res.data.forEach((itm) => {
                        if(itm.category==="All"){
                            tmp1.push(itm);
                        } else {
                            tmp2.push(itm);
                        }
                    });
                    setProductsData(tmp2.concat(tmp1).map((itm, ind) => ({
                        ...itm,
                        srno: ind + 1
                    })));
                }
            });
        
    }, [alertError]);


    const getImageFolderName = (item) => {
        const firstImage = item?.images?.find(Boolean);
        if (typeof firstImage === "string" && firstImage.includes("/")) {
            const [folderName] = firstImage.split("/");
            if (folderName) {
                return folderName;
            }
        }

        return getCategoryFolderName(item?.category || category);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        
        let found = productsData.filter((item) => String(item.title).toLowerCase()===itemName.toLowerCase());
        if(found.length!==0) {
            setAlertCont("Item already exists!!");
            setAlertError(1);
        }
        else {
            setAdding(true);
            const finalItemName = itemName[0].toUpperCase() + itemName.slice(1).toLowerCase();
            let images = [];
            const uploadImagePromises = itemImages.map(async (image) => {
                const formData = new FormData();
                formData.append('file', image);
                formData.append('folderName', getCategoryFolderName(category));
                return await httpClient.post('/upload-image', formData)
                    .then((res) => {
                        console.log(res);
                        images.push(res.data.file);
                    }).catch((err) => console.error(err));
            });
            await Promise.all(uploadImagePromises);
            console.log(images);
            httpClient.post('/allProductsData', {
                title: finalItemName,
                category: category,
                subcategory: subcategory,
                finalPrice: Number(salePrice),
                originalPrice: Number(salePrice) * 1.2,
                tag: tag,
                tagline: tagline,
                description: description,
                rateCount: 4.5,
                images: images,
                path: '/product-details/'
            })
            .then(() => {
                setAlertCont("New Item Added!!");
                setAlertError(2);
                setAdding(false);
                setItemName("");
                setCategory("");
                setSubcategory("");
                setSalePrice("");
                setTag("");
                setTagline("");
                setDescription("");
                setItemImages([]);
                revalidate(["/", "/all-products"]);
            })
            .catch(() => {
                setAlertCont("Failed to Add!!");
                setAlertError(1);
                setAdding(false);
            });
        }
        setTimeout(() => {
            setAlertError(0);
        }, 2000);
    };


    const handleEdit = async (item) => {
        setChId(item.id);
        setChItemName(item.title);
        setChCategory(item.category);
        handleChSubCategory(item.category);
        setChSubcategory(item.subcategory);
        setChSalePrice(item.finalPrice);
        setChTag(item.tag);
        setChTagline(item.tagline);
        setChDescription(item.description? item.description : "");
        // console.log(item.images);
        const folderName = getImageFolderName(item);
        await httpClient.get('/fetch-images?folderName=' + folderName + '&fileNames=' + (item.images || []).map(img => img.split('/')[1]).join(','))
        .then((res) => {
            console.log(res);
            setChItemImages((res.data.images || []).map(img => [folderName + '/' + img.name, img.url]));
        }).catch((err) => console.error(err));
        handleOpen();
    }

    const handleAddChImage = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            setChItemImages([...chItemImages, e.target.files[0]]);
        }
    }

    const handleDeleteChImage = (id) => {
        setChItemImages(chItemImages.filter((_, index) => index!==id));
    }

    const handleModalForm = async (e) => {
        e.preventDefault();
        let images = [];
        // Separate already uploaded images (string) and new files (File)
        const existingImages = chItemImages.filter(img => Array.isArray(img));
        const newImages = chItemImages.filter(img => !Array.isArray(img));
        // Upload new images
        const uploadImagePromises = newImages.map(async (image) => {
            const formData = new FormData();
            formData.append('file', image);
            formData.append('folderName', getCategoryFolderName(chCategory));
            return await httpClient.post('/upload-image', formData)
                .then((res) => {
                    images.push(res.data.file);
                }).catch((err) => console.error(err));
        });
        await Promise.all(uploadImagePromises);
        images = existingImages.map(img => img[0]).concat(images);
        httpClient.put("/allProductsData/" + chId, {
            title: chItemName,
            category: chCategory,
            subcategory: chSubcategory,
            finalPrice: Number(chSalePrice),
            tag: chTag,
            tagline: chTagline,
            description: chDescription,
            images: images
        })
        .then(() => {
            setAlertCont("Successfully Updated!!");
            setAlertError(2);
            revalidate(["/", "/all-products", "/product-details/" + chId]);
        })
        .catch(() => {
            setAlertCont("Failed to Update!!");
            setAlertError(1);
        });
        handleClose();
        setTimeout(() => {
            setAlertError(0);
        }, 2000);
    }


    const handleDelete = (item) => {
        httpClient.delete("/allProductsData/" + item.id)
        .then(() => {
            setAlertCont("Succesfully Deleted!!");
            setAlertError(2);
        })
        .catch(() => {
            setAlertCont("Failed to Delete!!");
            setAlertError(1);
        });

        setTimeout(() => {
            setAlertError(0);
        }, 2000);
    }

    const handleSubCategory = (cat) => {
        setCategory(cat);
        setSubcategory("");

        httpClient.get('/subcategoryData')
        .then(res => {
            // console.log(res);
            setSubcategoryData(res.data.filter(item => item.category===cat));
        });
    }

    const handleChSubCategory = (cat) => {
        setChCategory(cat);
        setChSubcategory("");
        
        httpClient.get('/subcategoryData')
        .then(res => {
            setChSubcategoryData(res.data.filter(item => item.category===cat));
        });
    }

    const handleTag = (tagName) => {
        if(tagName==="hero-product") {
            setTag(tagName);
        }
        else {
            setTag(tagName);
            setTagline("");
        }
    }

    const handleChTag = (tagName) => {
        if(tagName==="hero-product") {
            setChTag(tagName);
        }
        else {
            setChTag(tagName);
            setChTagline("");
        }
    }

    const handleAddImage = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            console.log(e.target.files[0]);
            setItemImages([...itemImages, e.target.files[0]]);
        }
    }

    const handleDeleteImage = (id) => {
        setItemImages(itemImages.filter((_, index) => index!==id));
    }

    return (
        <>
            { alertError > 0 ? 
                (<DocAlert alertCont={alertCont} alertError={alertError} />) : (
                    <Breadcrumbs className="breadcrumb">
                        <Link to="/" className="breadcrumb-active-link">Home</Link>
                        <Link to="/add-items">Items</Link>
                    </Breadcrumbs>
                )}

            <DocTitle title="Items"/>

            <section id="add-items">
                <div className="item-form">
                    <form onSubmit={handleSubmit} className="form">
                        <div className="form-group">
                            <label htmlFor="item-name">Item </label>
                            <input type="text" name="item-name" id="item-name" value={itemName} placeholder="Item Name" onChange={(e) => setItemName(e.target.value)} required/>
                            <div className="input-helper">Enter atleast 4 characters</div>
                        </div>
                        <div className="form-group select-input-grp">
                            <label htmlFor="cat-name">Category</label>
                            <select id="cat-name" name="cat-name" value={category} onChange={(e) => {handleSubCategory(e.target.value); setItemImages([]);}} required>
                                <option value="" disabled>Select Category</option>
                                { CategoryData.map((item,index) => (
                                    <option value={item.category} key={index}>{item.category}</option>
                                )) }
                            </select>
                            <div className="input-helper">Select the category</div>
                        </div>
                        <div className="form-group select-input-grp">
                            <label htmlFor="subcat-name">Subcategory</label>
                            { category==="All"? (
                                <input type="text" name="subcat-name" id="subcat-name" value={subcategory} onChange={(e) => setSubcategory(e.target.value)} required/>
                            ): (
                                <select id="subcat-name" name="subcat-name" value={subcategory} onChange={(e) => setSubcategory(e.target.value)} required>
                                    <option value="" disabled>Select Subcategory</option>
                                    { SubcategoryData.map((item,index) => (
                                        <option value={item.subcategory} key={index}>{item.subcategory}</option>
                                    )) }
                                </select>
                            )}
                            <div className="input-helper">Select the subcategory</div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="sale-price">Price</label>
                            <input type="text" name="sale-price" id="sale-price" value={salePrice} onChange={(e) => setSalePrice(e.target.value)} required={category!=="All"}/>
                            <div className="input-helper">Price ranging from 0</div>
                        </div>
                        <div className="form-group select-input-grp">
                            <label htmlFor="tag">Tag</label>
                            <select id="tag" name="tag" value={tag} onChange={(e) => handleTag(e.target.value)}>
                                <option value="">None</option>
                                <option value="hero-product">Hero Product</option>
                                <option value="featured-product">Featured Product</option>
                            </select>
                            <div className="input-helper">Select the Tag</div>
                        </div>
                        { tag==="hero-product" && (
                            <div className="form-group">
                                <label htmlFor="tagline">Tagline</label>
                                <input type="text" name="tagline" id="tagline" value={tagline} placeholder="Enter the Tagline" onChange={(e) => setTagline(e.target.value)} required/>
                                <div className="input-helper">Enter the Tagline</div>
                            </div>
                        )}
                        <div className="form-group">
                            <label htmlFor="item-desc">Description</label>
                            <textarea name="item-desc" id="item-desc" rows="5" value={description} placeholder="Describe something about it..." onChange={(e) => setDescription(e.target.value)} required></textarea>
                            <div className="input-helper">Describe the item</div>
                        </div>
                        {category!=="" && (
                            <div className="form-group">
                                <label>Image</label>
                                <div className="images-group">
                                    <div className="images-div">
                                        {itemImages.length > 0 && itemImages.map((image, index) => (
                                            <div key={index} className="image-div">
                                                <img src={URL.createObjectURL(image)} alt="" />
                                                <IconButton onClick={() => handleDeleteImage(index)}><HighlightOffIcon /></IconButton>
                                            </div>
                                        ))}
                                    </div>
                                    {itemImages.length < 4 && (
                                        <>
                                            <input type="file" name="item-image" accept="image/*" id="item-image" onChange={handleAddImage} style={{marginBottom: "10px"}} />
                                            <label htmlFor="item-image" className="add-image-btn">
                                                <AddIcon />
                                            </label>
                                        </>
                                    )}
                                </div>
                                <div className="input-helper">Add the image paths</div>
                            </div>
                        )}
                        { !adding && <button type="submit">Add</button>}
                        { adding && <button type="submit" className="active-btn" disabled>Adding...</button>}
                    </form>
                </div>
                
                <div className="item-table">
                    <DataGrid
                        columns={columns}
                        rows={productsData}
                        components={{Toolbar: GridToolbar}}
                        pageSize={pageSize}
                        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                        rowsPerPageOptions={[10,25,50,100]}
                        sx={{
                            ".MuiDataGrid-columnHeaders" : {
                                backgroundColor: "var(--white-color-3)",
                                fontSize: "1.1em",
                            },
                            ".MuiDataGrid-virtualScroller" : {
                                backgroundColor: "var(--white-color-1)",
                                fontSize: "1.1em",
                            },
                            ".MuiDataGrid-row:not(.MuiDataGrid-row--dynamicHeight) > .MuiDataGrid-cell": {
                                alignItems: "flex-start",
                                whiteSpace: "normal",
                                overflow: "auto",
                                padding: "5px"
                            }
                        }}
                        disableSelectionOnClick
                    />
                </div>

                <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <div className="item-modal-updation-form">
                        <div className="modal-close-icon-div">
                            <IconButton onClick={handleClose}>
                                <CloseIcon />
                            </IconButton>
                        </div>
                        <form onSubmit={handleModalForm} className="form">
                            <div className="form-group">
                                <label htmlFor="item-name">Item </label>
                                <input type="text" name="item-name" id="item-name" value={chItemName} placeholder="Item Name" onChange={(e) => setChItemName(e.target.value)} required/>
                            </div>
                            <div className="form-group select-input-grp">
                                <label htmlFor="cat-name">Category</label>
                                <select id="cat-name" name="cat-name" value={chCategory} onChange={(e) => handleChSubCategory(e.target.value)} required>
                                    <option value="" disabled>Select Category</option>
                                    { CategoryData.map((item,index) => (
                                        <option value={item.category} key={index}>{item.category}</option>
                                    )) }
                                </select>
                            </div>
                            <div className="form-group select-input-grp">
                                <label htmlFor="subcat-name">Subcategory</label>
                                <select id="subcat-name" name="subcat-name" value={chSubcategory} onChange={(e) => setChSubcategory(e.target.value)} required>
                                    <option value="" disabled>Select Subcategory</option>
                                    { chSubcategoryData.map((item,index) => (
                                        <option value={item.subcategory} key={index}>{item.subcategory}</option>
                                    )) }
                                </select>
                            </div>
                            <div className="form-group">
                                <label htmlFor="sale-price">Sale Price</label>
                                <input type="text" name="sale-price" id="sale-price" value={chSalePrice} onChange={(e) => setChSalePrice(e.target.value)} required={chCategory!=="All"}/>
                            </div>
                            <div className="form-group select-input-grp">
                                <label htmlFor="tag">Tag</label>
                                <select id="tag" name="tag" value={chTag} onChange={(e) => handleChTag(e.target.value)}>
                                    <option value="">None</option>
                                    <option value="hero-product">Hero Product</option>
                                    <option value="featured-product">Featured Product</option>
                                </select>
                            </div>
                            { chTag==="hero-product" && (
                                <div className="form-group">
                                    <label htmlFor="tagline">Tagline</label>
                                    <input type="text" name="tagline" id="tagline" value={chTagline} placeholder="Enter the Tagline" onChange={(e) => setChTagline(e.target.value)} required/>
                                </div>
                            )}
                            <div className="form-group">
                                <label htmlFor="item-desc">Description</label>
                                <textarea name="item-desc" id="item-desc" rows="5" value={chDescription} placeholder="Describe something about it..." onChange={(e) => setChDescription(e.target.value)} required></textarea>
                            </div>
                            <div className="form-group">
                                <label>Image</label>
                                <div className="images-group">
                                    <div className="images-div">
                                        {chItemImages.length > 0 && chItemImages.map((image, index) => (
                                            <div key={index} className="image-div">
                                                {Array.isArray(image) ? (
                                                    <img src={image[1]} alt="" />
                                                ) : (
                                                    <img src={URL.createObjectURL(image)} alt="" />
                                                )}
                                                <IconButton onClick={() => handleDeleteChImage(index)}><HighlightOffIcon /></IconButton>
                                            </div>
                                        ))}
                                    </div>
                                    {chItemImages.length < 4 && (
                                        <>
                                            <input type="file" name="ch-item-image" accept="image/*" id="ch-item-image" onChange={handleAddChImage} style={{marginBottom: "10px"}} />
                                            <label htmlFor="ch-item-image" className="add-image-btn">
                                                <AddIcon />
                                            </label>
                                        </>
                                    )}
                                </div>
                                <div className="input-helper">Add or remove images</div>
                            </div>
                            <button type="submit">Update</button>
                        </form>
                    </div>
                </Modal>

            </section>
        </>
    )
};

export default AddItem;